export enum TextOption {
  EXPANSIBLE = 'expansible',
  STATIC = 'static',
  TOOLTIP = 'tooltip',
}
